module.exports = __webpack_public_path__ + "static/bg-office-ecuador-411b7d244b41df09857690a49a1a6f66.png";